<template src='./myAccountModal.pug' lang='pug'></template>

<script>
import Modal from '../modal/Modal'
import ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'
import { trackAnalyticsEvent } from '../../../utils/analytics.js'

export default {
  name: 'MyAccountModal',

  components: {
    Modal,
    ButtonPrimary
  },

  data () {
    return {
      name: this.$store.getters.user,
      email: this.$store.getters.userEmail,
      accessProfileName: this.$store.getters.accessProfileName,
      currentPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      changingPassword: false,
      hidePasswordIcon: 'fa-eye',
      saveBtnDisabled: false,
      differentNewPassword: false
    }
  },

  computed: {
    openMyAccountModal () {
      return this.$store.getters.openMyAccountModal
    }
  },

  watch: {
    openMyAccountModal () {
      if (this.$store.getters.isLoggedIn) {
        this.showModal()
      }
    }
  },

  methods: {
    showModal () {
      this.name = this.$store.getters.user
      this.accessProfileName = this.$store.getters.accessProfileName
      this.$nextTick(() => {
        this.$validator.reset()
      })
      $('#my-account-modal').modal({
        backdrop: 'static',
        keyboard: false
      })
    },

    validate () {
      this.saveBtnDisabled = true
      this.differentNewPassword = false
      this.$validator.validateAll()
        .then((result) => {
          if (result && this.changingPassword) {
            // Se estiver mudando a senha
            if (this.newPassword !== '' && this.currentPassword !== '') {
              if (this.newPassword !== this.confirmNewPassword) {
                this.differentNewPassword = true
                this.saveBtnDisabled = false
              } else {
                this.updateAccount()
              }
            } else {
              this.saveBtnDisabled = false
            }
          } else if (result) {
            // Se estiver mundando só o nome
            this.updateAccount()
          } else {
            this.saveBtnDisabled = false
          }
        })
    },

    closeModal () {
      this.changingPassword = false
      this.currentPassword = ''
      this.newPassword = ''
      this.confirmNewPassword = ''
      $('#my-account-modal').modal('hide')
    },

    updateAccount () {
      this.$store.dispatch('updateAccount', {
        name: this.name,
        email: this.email,
        currentPassword: this.currentPassword,
        newPassword: this.newPassword
      }).then((user) => {
        this.$store.dispatch('updateUserName', user.nome)
        this.closeModal()
      }).then(() => {
        this.$root.$refs.notification.success('modalMinhaConta.sucesso.salvar')
        this.saveBtnDisabled = false
      }).catch((error) => {
        this.$root.$refs.notification.error(error.message)
        this.saveBtnDisabled = false
      })
    },

    showPassword (idInput, idButton) {
      this.togglePasswordInputType(idInput, idButton)
    },

    togglePasswordInputType (idInput, idButton) {
      if (document.getElementById(idInput).type === 'text') {
        document.getElementById(idInput).type = 'password'
        document.querySelector(idButton).style.color = '#999'
      } else {
        document.getElementById(idInput).type = 'text'
        document.querySelector(idButton).style.color = '#333'
      }
    },

    changePassword () {
      trackAnalyticsEvent(this, 'button-click', 'button-default-component', 'edit-password-btn')
      this.changingPassword = true
    }
  }
}
</script>

<style scoped>
/* Fix da posição da label de controle em negrito */
.col-xs-12.row-filter-medium > label.control-label {
  width: 100%;
}

#edit-password-btn {
  margin-left: 10px;
  color: #fff;
  padding: 0;
  background-color: #34b8ba;
  height: 20px;
  width: 20px;
  border: none;

  border: 1px solid transparent;
  border-color: #46b8da;
  border-radius: 4px;
}

button.btn-change-password,
button.btn-change-password:hover,
button.btn-change-password:focus {
  border-color: #ccc;
  border-left: none;
  background: #fff;
  box-shadow: none;
  color: #999;
  font-size: 18px;
  border-radius: 0px 4px 4px 0px!important;
}

button.btn-change-password.is-danger{
  border-color: #ff3860;
  border-left: 1px solid #ccc;
}

.label-bold {
  font-family: 'Inter', sans-serif !important;
font-weight: 700;
}

.is-danger {
  border-color: #ff3860;
}

.is-danger input {
  border-color: #ff3860;
}
</style>



// WEBPACK FOOTER //
// MyAccountModal.vue?cffa9cde